import { useEffect, useState } from 'react';

import { debounce } from '@/shared/services/tools';

interface IProps {
  element: HTMLElement | string | null;
}

const useResize = ({ element }: IProps) => {
  const [size, setSize] = useState([0, 0]);

  const handleSizeChanged = () => {
    let newSize: [number, number];
    if (typeof element === 'string') {
      element = document.querySelector(element) as HTMLElement;
    }
    if (element) {
      const bounds = element.getBoundingClientRect();
      newSize = [bounds.width, bounds.height];
    } else {
      newSize = [window.innerWidth, window.innerHeight];
    }
    setSize(newSize);
  };
  const getSize = debounce(handleSizeChanged, 200);

  useEffect(() => {
    getSize();
    window.addEventListener('resize', getSize);
    const observer = new ResizeObserver(getSize);
    if (element) {
      observer.observe(element as HTMLElement);
    }
    return () => {
      window.removeEventListener('resize', getSize);
      observer.disconnect();
    };
  }, [element]);

  return size;
};

export default useResize;
